import { render } from "./myQuestion.vue?vue&type=template&id=08936716&scoped=true"
import script from "./myQuestion.js?vue&type=script&lang=js"
export * from "./myQuestion.js?vue&type=script&lang=js"

import "./myQuestion.vue?vue&type=style&index=0&id=08936716&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08936716"]])

export default __exports__